
import { Button, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom"
import FileSaver from "file-saver";
import XLSX from "sheetjs-style"
import { IDadosExportSalarios, JogadorService } from "../../services/api/jogador/JogadorService";
import { IDadosModal } from "../modal/DialogMensagem";
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import { UtilidadeService } from "../../services/api/utilidades/UtilidadesService";
import { FranquiaService, IDadosExportMeuTime } from "../../services/api/franquia/FranquiaService";

export type IExportProps = {

    children?: React.ReactNode;
    nomeArquivo: string;
    codigoFranquia: number;
}
export const DonwloadDadosFranquia: React.FC<IExportProps> = ({ nomeArquivo, codigoFranquia }) => {
    //const [dados, setDados] = useState<IDadosExportSalarios[]>([]);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [loading, setLoading] = useState(false);
    const [redirecionar, setRedirecionar] = useState("0");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Exportação não realizada!",
        display: "none",
        titulo: "Atenção"
    });
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml,sheet;charser=UTF-8";
    const fileExtension = ".xlsx";
    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options);
    const CarregarDadosExportMeuTime = async () => {
        setLoading(true);       
        if (codigoLiga !== undefined && Number(codigoLiga) > 0) {            
            await FranquiaService.getByIdLigaIdUsuarioToExcel(codigoFranquia,Number(codigoLiga))
                .then((result) => {
                    setLoading(false);
                    setShowModalMensagem(false);                   
                    let resultado = result.dado;
                    for (var key in resultado) {
                        if (resultado[key].dreb === null) {                            
                            delete resultado[key].dreb;
                        }
                        else{
                            resultado[key].dreb = Number(resultado[key].dreb?.toFixed(2));
                        }
                        if (resultado[key].fga === null) {
                            delete resultado[key].fga;
                        }
                        else{
                            resultado[key].fga = Number(resultado[key].fga?.toFixed(2));
                        }
                        if (resultado[key].fge === null) {
                            delete resultado[key].fge;
                        }
                        else{
                            resultado[key].fge = Number(resultado[key].fge?.toFixed(2));
                        }
                        if (resultado[key].fgm === null) {
                            delete resultado[key].fgm;
                        }
                        else{
                            resultado[key].fgm = Number(resultado[key].fgm?.toFixed(2));
                        }
                        if (resultado[key].fgmp === null) {
                            delete resultado[key].fgmp;
                        }
                        else{
                            resultado[key].fgmp = Number(resultado[key].fgmp?.toFixed(3));
                        }
                        if (resultado[key].fta === null) {
                            delete resultado[key].fta;
                        }
                        else{
                            resultado[key].fta = Number(resultado[key].fta?.toFixed(2));
                        }
                        if (resultado[key].fte === null) {
                            delete resultado[key].fte;
                        }
                        else{
                            resultado[key].fte = Number(resultado[key].fte?.toFixed(2));
                        }
                        if (resultado[key].ftm === null) {
                            delete resultado[key].ftm;
                        }
                        else{
                            resultado[key].ftm = Number(resultado[key].ftm?.toFixed(2));
                        }
                        if (resultado[key].ftmp === null) {
                            delete resultado[key].ftmp;
                        }
                        else{
                            resultado[key].ftmp = Number(resultado[key].ftmp?.toFixed(2));
                        }
                        if (resultado[key].mplu === null) {
                            delete resultado[key].mplu;
                        }
                        else{
                            resultado[key].mplu = Number(resultado[key].mplu?.toFixed(2));
                        }
                        if (resultado[key].oreb === null) {
                            delete resultado[key].oreb;
                        }
                        else{
                            resultado[key].oreb = Number(resultado[key].oreb?.toFixed(2));
                        }
                        if (resultado[key].peso_Total_Jogador === null) {
                            delete resultado[key].peso_Total_Jogador;
                        }
                        else{
                            resultado[key].peso_Total_Jogador = Number(resultado[key].peso_Total_Jogador?.toFixed(3));
                        }
                        if (resultado[key].pf === null) {
                            delete resultado[key].pf;
                        }
                        else{
                            resultado[key].pf = Number(resultado[key].pf?.toFixed(2));
                        }
                        if (resultado[key].pts === null) {
                            delete resultado[key].pts;
                        }
                        else{
                            resultado[key].pts = Number(resultado[key].pts?.toFixed(2));
                        }
                        if (resultado[key].quantidade_Jogos === null) {
                            delete resultado[key].quantidade_Jogos;
                        }
                        if (resultado[key].reb === null) {
                            delete resultado[key].reb;
                        }
                        else{
                            resultado[key].reb = Number(resultado[key].reb?.toFixed(2));
                        }
                        if (resultado[key].stocks === null) {
                            delete resultado[key].stocks;
                        }
                        else{
                            resultado[key].stocks = Number(resultado[key].stocks?.toFixed(2));
                        }
                        if (resultado[key].threepa === null) {
                            delete resultado[key].threepa;
                        }
                        else{
                            resultado[key].threepa = Number(resultado[key].threepa?.toFixed(2));
                        }
                        if (resultado[key].threepe === null) {
                            delete resultado[key].threepe;
                        }
                        else{
                            resultado[key].threepe = Number(resultado[key].threepe?.toFixed(2));
                        }
                        if (resultado[key].threepm === null) {
                            delete resultado[key].threepm;
                        }
                        else{
                            resultado[key].threepm = Number(resultado[key].threepm?.toFixed(3));
                        }
                        if (resultado[key].threepmp === null) {
                            delete resultado[key].threepmp;
                        }
                        else{
                            resultado[key].threepmp = Number(resultado[key].threepmp?.toFixed(3));
                        }
                        if (resultado[key].blk === null) {
                            delete resultado[key].blk;
                        }
                        else{
                            resultado[key].blk = Number(resultado[key].blk?.toFixed(2));
                        }
                        if (resultado[key].ast === null) {
                            delete resultado[key].ast;
                        }
                        else{
                            resultado[key].ast = Number(resultado[key].ast?.toFixed(2));
                        }
                        if (resultado[key].stl === null) {
                            delete resultado[key].stl;
                        }
                        else{
                            resultado[key].stl = Number(resultado[key].stl?.toFixed(2));
                        }
                        if (resultado[key].to === null) {
                            delete resultado[key].to;
                        }
                        else{
                            resultado[key].to = Number(resultado[key].to?.toFixed(2));
                        }
                        if (resultado[key].min === null) {
                            delete resultado[key].min;
                        }
                        else{
                            resultado[key].min = Number(resultado[key].min?.toFixed(2));
                        }
                        delete resultado[key].foto;
                        delete resultado[key].codigo;

                        resultado[key].salario_1 = formatNumber.format(Number(resultado[key].salario_1));
                        if (resultado[key].salario_2 !== null) {
                            resultado[key].salario_2 = formatNumber.format(Number(resultado[key].salario_2));
                        }
                        if (resultado[key].salario_3 !== null) {
                            resultado[key].salario_3 = formatNumber.format(Number(resultado[key].salario_3));
                        }
                        if (resultado[key].salario_4 !== null) {
                            resultado[key].salario_4 = formatNumber.format(Number(resultado[key].salario_4));
                        }
                        if (resultado[key].salario_5 !== null) {
                            resultado[key].salario_5 = formatNumber.format(Number(resultado[key].salario_5));
                        }
                    }
                    exportToExcel(resultado);
                }).catch((errors) => {
                    setShowModalMensagem(true);
                    setLoading(false);
                    if (errors.response !== undefined && errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar("-1");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
    }

    function removeNullObjects(arr: IDadosExportMeuTime[]) {
        let cleanedArray: IDadosExportMeuTime[] = [];



        return cleanedArray;
    }

    // const carregarCabecalhoTemporadas = (codigo: number) => {
    //     UtilidadeService.getDescricaoTemporadoPorCodigoLiga(codigo)
    //         .then((result) => {
    //             setIsLoading(false);
    //             const tmps = result.dado;
    //             setAno1(tmps.descricao_Ano1);
    //             setAno2(tmps.descricao_Ano2);
    //             setAno3(tmps.descricao_Ano3);
    //             setAno4(tmps.descricao_Ano4);
    //             setAno5(tmps.descricao_Ano5);
    //         })
    //         .catch((errors) => {
    //             setShowModalMensagem(true);
    //             setRemoveLoading(true);
    //             if (errors.response.status === 401) {
    //                 setDadosModal({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "info",
    //                     mensagem: "Sessão expirada!",
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //                 logout();
    //                 setRedirecionar("0");
    //                 return;
    //             }
    //             setDadosModal({
    //                 acao: true,
    //                 label: "",
    //                 tipo: "error",
    //                 mensagem: errors.response.data.mensagem,
    //                 display: "none",
    //                 titulo: "Atenção"
    //             });
    //         });
    // }

    const exportToExcel = async (dados: IDadosExportMeuTime[]) => {
        const ws = XLSX.utils.json_to_sheet(dados);
        const wb = { Sheets: { "data": ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, nomeArquivo + fileExtension);
    }
    return (
        <>
            <Tooltip title="Exportar Time">
                <LoadingButton variant="contained"
                    onClick={(e) => CarregarDadosExportMeuTime()} color="primary"
                    style={{ cursor: "pointer" }}
                    endIcon={<SaveIcon />}
                    loading={loading}
                    loadingPosition="end"
                >
                    Exportar Time
                </LoadingButton >
            </Tooltip>
        </>

    )
}